/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Blob_Save_Dialog_Search_DestinationInputs */



/**
* | output |
* | --- |
* | "Search spaces & projects..." |
*
* @param {Chat_Blob_Save_Dialog_Search_DestinationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_save_dialog_search_destination = /** @type {((inputs?: Chat_Blob_Save_Dialog_Search_DestinationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_Save_Dialog_Search_DestinationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spaces & Projekte durchsuchen...")
	return /** @type {LocalizedString} */ ("Search spaces & projects...")
});